import * as S from './InvoiceLineDetailsDialog.css';

type Props = {
  label: string;
  data: string | number;
};

export const DetailsField = ({ label, data }: Props) => (
    <S.FieldGroup>
      <S.FieldTitle>{label}</S.FieldTitle>
      <S.FieldData>{data}</S.FieldData>
    </S.FieldGroup>
  );
